import OurImpact from "@/pages/OurImpact";
// Reuse the same listing for Blogs route
export default function Blogs() {
  return <OurImpact />;
}
